import { Card, CardHeader, CardContent } from '@/components/ui/Card';
import { Badge } from '@/components/ui/Badge';
import { EmptyState } from '@/components/ui/EmptyState';
import { Globe, Folder } from 'lucide-react';
import { Link } from 'react-router-dom';

interface OrgDomainsCardProps {
  org: any;
}

export function OrgDomainsCard({ org }: OrgDomainsCardProps) {
  const domains = (org.domains || []) as Array<{
    uuid: string;
    name: string;
    lastSyncStatus: string;
    folderCount?: number;
    isArchived?: boolean;
  }>;

  return (
    <Card>
      <CardHeader title="Domaines" description={`${domains.length} domaine(s)`} />
      <CardContent>
        {domains.length === 0 ? (
          <EmptyState message="Aucun domaine" icon={<Globe className="h-8 w-8" />} />
        ) : (
          <div className="space-y-2">
            {domains.map((domain) => (
              <Link
                key={domain.uuid}
                to={`/domains/${domain.uuid}`}
                className="flex items-center justify-between rounded-lg bg-neutral-100 dark:bg-neutral-800/50 p-3 hover:bg-neutral-200 dark:hover:bg-neutral-700/50 transition-colors"
              >
                <div className="flex items-center gap-2">
                  <Globe className="h-4 w-4 text-neutral-400" />
                  <div>
                    <p className="text-sm text-neutral-700 dark:text-neutral-300">{domain.name}</p>
                    <p className="text-xs text-neutral-500 flex items-center gap-1">
                      <Folder className="h-3 w-3" />
                      {domain.folderCount ?? 0} dossier(s)
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  {domain.isArchived && (
                    <Badge variant="neutral">Archivé</Badge>
                  )}
                  <Badge variant={domain.lastSyncStatus === 'success' ? 'success' : domain.lastSyncStatus === 'error' ? 'danger' : 'neutral'}>
                    {domain.lastSyncStatus || 'N/A'}
                  </Badge>
                </div>
              </Link>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
